import ProjectTeamManageModalComponent from './manage-modal.component'

const ProjectTeamManageModalModule = angular.module('cdbl.project-team.manage-modal', [

])
  .component('cdblProjectTeamManageModal', ProjectTeamManageModalComponent)
  .name

export default ProjectTeamManageModalModule
